import React from 'react'

export default function Map() {
  return (
    <div>
        <div className="text-center mt-[120px] mb-[32px] text-4xl text-center font-semibold">My Location</div>
          <iframe className='w-full h-[420px] rounded-md shadow-xl mb-[70px]' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3090.760560500721!2d91.27962237697844!3d22.89291172062784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x37535998a715216d%3A0x9b622d6c1587a61f!2z4Ka54Ka-4Kac4KeAIOCmqOCmvuCmpuCnh-CmsOCnh-CmsCDgppzgpr7gpq7gpr7gpqgg4Kac4Ka-4Kau4KeHIOCmruCmuOCmnOCmv-Cmpg!5e0!3m2!1sen!2sbd!4v1654851816616!5m2!1sen!2sbd"  style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  )
}
